<div class="kanban-config-page" *ngIf="permitido">
  <div class="kanban-config-header">
    <div>
      <h1>CRM(Config)</h1>
      <p>Configure departamentos, etapas do funil e acesso dos vendedores.</p>
    </div>

    <button class="btn btn-outline-secondary" type="button" (click)="carregar()" [disabled]="carregando">
      Atualizar
    </button>
  </div>

  <div class="kanban-config-grid">
    <section class="config-card">
      <div class="config-card-title">
        <h2>Departamentos</h2>
        <span>{{ departamentos.length }}</span>
      </div>

      <div class="department-list">
        <button
          type="button"
          class="department-pill"
          *ngFor="let departamento of departamentos"
          [class.active]="departamento.id === departamentoSelecionadoId"
          (click)="selecionarDepartamento(departamento.id)">
          <strong>{{ departamento.nome }}</strong>
          <small>{{ departamento.ativo ? 'Ativo' : 'Inativo' }}</small>
        </button>
      </div>

      <div class="inline-form" *ngIf="departamentoEditando">
        <h3>Editar departamento</h3>

        <label>Nome</label>
        <input class="form-control" [(ngModel)]="departamentoEditando.nome" />

        <label>Descricao</label>
        <input class="form-control" [(ngModel)]="departamentoEditando.descricao" />

        <div class="form-row-compact">
          <div>
            <label>Ordem</label>
            <input class="form-control" type="number" [(ngModel)]="departamentoEditando.ordem" />
          </div>

          <label class="checkbox-line">
            <input type="checkbox" [(ngModel)]="departamentoEditando.ativo" />
            Ativo
          </label>
        </div>

        <button class="btn btn-primary btn-block" type="button" (click)="salvarDepartamento(departamentoEditando, false)">
          Salvar departamento
        </button>
      </div>

      <div class="inline-form new-box">
        <h3>Novo departamento</h3>

        <input class="form-control" placeholder="Nome" [(ngModel)]="novoDepartamento.nome" />
        <input class="form-control" placeholder="Descricao" [(ngModel)]="novoDepartamento.descricao" />

        <div class="form-row-compact">
          <input class="form-control" type="number" placeholder="Ordem" [(ngModel)]="novoDepartamento.ordem" />

          <label class="checkbox-line">
            <input type="checkbox" [(ngModel)]="novoDepartamento.ativo" />
            Ativo
          </label>
        </div>

        <button class="btn btn-success btn-block" type="button" (click)="salvarDepartamento(novoDepartamento, true)">
          Criar departamento
        </button>
      </div>
    </section>

    <section class="config-card wide-card">
      <div class="config-card-title">
        <h2>Etapas do funil</h2>
        <span>{{ etapasDoDepartamento().length }}</span>
      </div>

      <div class="selected-context" *ngIf="departamentoEditando">
        Departamento selecionado: <strong>{{ departamentoEditando.nome }}</strong>
      </div>

      <div class="stage-table">
        <div class="stage-row stage-head">
          <span>Nome</span>
          <span>Tipo</span>
          <span>Ordem</span>
          <span>Ativo</span>
          <span></span>
        </div>

        <div class="stage-row" *ngFor="let etapa of etapasDoDepartamento()">
          <input class="form-control" [(ngModel)]="etapa.nome" />

          <select class="form-control" [(ngModel)]="etapa.tipo">
            <option *ngFor="let tipo of tiposEtapa" [value]="tipo">{{ tipo }}</option>
          </select>

          <input class="form-control" type="number" [(ngModel)]="etapa.ordem" />

          <label class="checkbox-center">
            <input type="checkbox" [(ngModel)]="etapa.ativo" />
          </label>

          <button class="btn btn-outline-primary" type="button" (click)="salvarEtapa(etapa, false)">
            Salvar
          </button>
        </div>
      </div>

      <div class="inline-form new-stage">
        <h3>Nova etapa</h3>

        <div class="stage-row">
          <input class="form-control" placeholder="Nome da etapa" [(ngModel)]="novaEtapa.nome" />

          <select class="form-control" [(ngModel)]="novaEtapa.tipo">
            <option *ngFor="let tipo of tiposEtapa" [value]="tipo">{{ tipo }}</option>
          </select>

          <input class="form-control" type="number" [(ngModel)]="novaEtapa.ordem" />

          <label class="checkbox-center">
            <input type="checkbox" [(ngModel)]="novaEtapa.ativo" />
          </label>

          <button class="btn btn-success" type="button" (click)="salvarEtapa(novaEtapa, true)">
            Criar
          </button>
        </div>
      </div>
    </section>
  </div>

  <section class="config-card form-card" *ngIf="departamentoEditando">
    <div class="config-card-title">
      <h2>Formularios do departamento</h2>
      <span>{{ formulariosDoDepartamento().length }}</span>
    </div>

    <p class="muted-line">
      Todo formulario possui como base: <strong>Nome do negocio</strong>, <strong>Cliente</strong>, <strong>Data fechamento</strong> e <strong>Vendedor responsavel</strong>.
    </p>

    <div class="form-config-grid">
      <div>
        <div class="department-list">
          <button
            type="button"
            class="department-pill"
            *ngFor="let formulario of formulariosDoDepartamento()"
            [class.active]="formulario.id === formularioSelecionadoId"
            (click)="selecionarFormulario(formulario.id)">
            <strong>{{ formulario.nome }}</strong>
            <small>{{ formulario.ativo ? 'Ativo' : 'Inativo' }}</small>
          </button>
        </div>

        <div class="inline-form" *ngIf="formularioEditando">
          <h3>Editar formulario</h3>
          <input class="form-control" placeholder="Nome" [(ngModel)]="formularioEditando.nome" />
          <input class="form-control" placeholder="Descricao" [(ngModel)]="formularioEditando.descricao" />
          <div class="form-row-compact">
            <input class="form-control" type="number" placeholder="Ordem" [(ngModel)]="formularioEditando.ordem" />
            <label class="checkbox-line"><input type="checkbox" [(ngModel)]="formularioEditando.ativo" /> Ativo</label>
          </div>
          <button class="btn btn-primary btn-block" type="button" (click)="salvarFormulario(formularioEditando, false)">Salvar formulario</button>
        </div>

        <div class="inline-form new-box">
          <h3>Novo formulario</h3>
          <input class="form-control" placeholder="Nome do formulario" [(ngModel)]="novoFormulario.nome" />
          <input class="form-control" placeholder="Descricao" [(ngModel)]="novoFormulario.descricao" />
          <div class="form-row-compact">
            <input class="form-control" type="number" placeholder="Ordem" [(ngModel)]="novoFormulario.ordem" />
            <label class="checkbox-line"><input type="checkbox" [(ngModel)]="novoFormulario.ativo" /> Ativo</label>
          </div>
          <button class="btn btn-success btn-block" type="button" (click)="salvarFormulario(novoFormulario, true)">Criar formulario</button>
        </div>
      </div>

      <div *ngIf="formularioSelecionadoId">
        <div class="config-card-title compact-title">
          <h2>Campos</h2>
          <span>{{ camposDoFormulario().length }}</span>
        </div>

        <div class="field-table">
          <div class="field-row field-head">
            <span>Nome</span>
            <span>Chave</span>
            <span>Tipo</span>
            <span>Obrig.</span>
            <span>Ativo</span>
            <span>Ordem</span>
            <span></span>
          </div>

          <div class="field-row" *ngFor="let campo of camposDoFormulario()">
            <input class="form-control" [(ngModel)]="campo.nome" />
            <input class="form-control" [(ngModel)]="campo.chave" [disabled]="campoPadrao(campo.chave)" />
            <select class="form-control" [(ngModel)]="campo.tipo" [disabled]="campoPadrao(campo.chave)">
              <option *ngFor="let tipo of tiposCampo" [value]="tipo">{{ tipo }}</option>
            </select>
            <label class="checkbox-center"><input type="checkbox" [(ngModel)]="campo.obrigatorio" /></label>
            <label class="checkbox-center"><input type="checkbox" [(ngModel)]="campo.ativo" /></label>
            <input class="form-control" type="number" [(ngModel)]="campo.ordem" />
            <button class="btn btn-outline-primary" type="button" (click)="salvarCampo(campo, false)">Salvar</button>

            <div class="field-default" *ngIf="campo.chave === 'data_fechamento_prevista'">
              <strong>Dias para data prevista</strong>
              <input class="form-control" type="number" min="0" placeholder="Ex: 7" [(ngModel)]="campo.valor_padrao" />
              <span class="muted-line">Informe quantos dias a partir da data atual devem ser usados nos novos cards. Se ficar em branco, o card abre sem data prevista.</span>
            </div>

            <div class="field-options" *ngIf="campo.tipo === 'ALTERNATIVA'">
              <strong>Opcoes</strong>
              <div class="option-row" *ngFor="let opcao of opcoesDoCampo(campo.id)">
                <input class="form-control" [(ngModel)]="opcao.nome" />
                <input class="form-control" [(ngModel)]="opcao.valor" />
                <input class="form-control" type="number" [(ngModel)]="opcao.ordem" />
                <label class="checkbox-center"><input type="checkbox" [(ngModel)]="opcao.ativo" /></label>
                <button class="btn btn-outline-primary" type="button" (click)="editarOpcao(opcao)">Salvar</button>
              </div>
              <div class="option-row">
                <input class="form-control" placeholder="Nova opcao" [(ngModel)]="novaOpcaoPorCampo[campo.id].nome" />
                <input class="form-control" placeholder="Valor" [(ngModel)]="novaOpcaoPorCampo[campo.id].valor" />
                <input class="form-control" type="number" [(ngModel)]="novaOpcaoPorCampo[campo.id].ordem" />
                <span></span>
                <button class="btn btn-success" type="button" (click)="salvarOpcao(campo)">Criar</button>
              </div>
            </div>
          </div>
        </div>

        <div class="inline-form new-stage">
          <h3>Novo campo</h3>
          <div class="field-row">
            <input class="form-control" placeholder="Nome do campo" [(ngModel)]="novoCampo.nome" />
            <input class="form-control" placeholder="chave_do_campo" [(ngModel)]="novoCampo.chave" />
            <select class="form-control" [(ngModel)]="novoCampo.tipo">
              <option *ngFor="let tipo of tiposCampo" [value]="tipo">{{ tipo }}</option>
            </select>
            <label class="checkbox-center"><input type="checkbox" [(ngModel)]="novoCampo.obrigatorio" /></label>
            <label class="checkbox-center"><input type="checkbox" [(ngModel)]="novoCampo.ativo" /></label>
            <input class="form-control" type="number" [(ngModel)]="novoCampo.ordem" />
            <button class="btn btn-success" type="button" (click)="salvarCampo(novoCampo, true)">Criar</button>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="config-card seller-card" *ngIf="departamentoEditando">
    <div class="config-card-title">
      <h2>Seller x Departamento</h2>
      <span>{{ sellers.length }}</span>
    </div>

    <p class="muted-line">
      Controle quem acessa o departamento <strong>{{ departamentoEditando.nome }}</strong> e quais acoes esse usuario pode executar.
    </p>

    <div class="seller-table">
      <div class="seller-row seller-head">
        <span>Vendedor</span>
        <span>Acesso</span>
        <span>Criar</span>
        <span>Editar</span>
        <span>Mover</span>
        <span></span>
      </div>

      <div class="seller-row" *ngFor="let vinculo of vinculosVisiveis">
        <strong>{{ vinculo.seller_nome }}</strong>

        <label><input type="checkbox" [(ngModel)]="vinculo.ativo" /></label>
        <label><input type="checkbox" [(ngModel)]="vinculo.pode_criar" /></label>
        <label><input type="checkbox" [(ngModel)]="vinculo.pode_editar" /></label>
        <label><input type="checkbox" [(ngModel)]="vinculo.pode_mover" /></label>

        <button class="btn btn-outline-primary" type="button" (click)="salvarVinculo(vinculo)">
          Salvar
        </button>
      </div>
    </div>
  </section>
</div>

<div class="kanban-config-denied" *ngIf="!permitido">
  <h1>Acesso restrito</h1>
  <p>Essa configuracao esta disponivel apenas para usuarios Master ou Diretoria.</p>
</div>
